"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

//fa-info-circle
var Info = function Info() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M309.3,356v-33.3c0-1.9-0.6-3.5-1.9-4.8c-1.2-1.2-2.8-1.9-4.8-1.9h-20V209.3c0-1.9-0.6-3.5-1.9-4.8 c-1.2-1.2-2.8-1.9-4.8-1.9h-66.7c-1.9,0-3.5,0.6-4.8,1.9s-1.9,2.8-1.9,4.8v33.3c0,1.9,0.6,3.5,1.9,4.8c1.2,1.2,2.8,1.9,4.8,1.9h20 V316h-20c-1.9,0-3.5,0.6-4.8,1.9c-1.2,1.2-1.9,2.8-1.9,4.8V356c0,1.9,0.6,3.5,1.9,4.8c1.2,1.2,2.8,1.9,4.8,1.9h93.3 c1.9,0,3.5-0.6,4.8-1.9C308.7,359.5,309.3,357.9,309.3,356z M282.7,169.3V136c0-1.9-0.6-3.5-1.9-4.8c-1.2-1.2-2.8-1.9-4.8-1.9h-40 c-1.9,0-3.5,0.6-4.8,1.9s-1.9,2.8-1.9,4.8v33.3c0,1.9,0.6,3.5,1.9,4.8c1.2,1.2,2.8,1.9,4.8,1.9h40c1.9,0,3.5-0.6,4.8-1.9 C282,172.9,282.7,171.3,282.7,169.3z M416,256c0,29-7.2,55.8-21.5,80.3c-14.3,24.5-33.7,43.9-58.2,58.2C311.8,408.8,285,416,256,416 s-55.8-7.2-80.3-21.5s-43.9-33.7-58.2-58.2S96,285,96,256s7.2-55.8,21.5-80.3c14.3-24.5,33.7-43.9,58.2-58.2S227,96,256,96 s55.8,7.2,80.3,21.5c24.5,14.3,43.9,33.7,58.2,58.2C408.8,200.2,416,227,416,256z"
  }));
};

Info.displayName = 'Info';
var _default = Info;
exports["default"] = _default;
Info.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Info"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Info.js"] = {
    name: "Info",
    docgenInfo: Info.__docgenInfo,
    path: "src/Info.js"
  };
}